import { render, staticRenderFns } from "./PartProjects.vue?vue&type=template&id=feb68140&"
import script from "./PartProjects.vue?vue&type=script&lang=js&"
export * from "./PartProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports